'use client'

import { motion } from 'framer-motion'
import { Reveal } from '../Reveal'
import { processSteps } from '@/lib/site-config'

export function Process(): React.ReactElement {
  return (
    <section className="section-pad relative overflow-hidden bg-charcoal-950">
      <div className="absolute -bottom-24 left-0 h-72 w-72 rounded-full bg-gold-500/10 blur-3xl" />

      <div className="container-x relative">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow mb-5">خطوات العمل</span>
          <h2 className="font-heading text-3xl font-extrabold text-white sm:text-4xl md:text-5xl">
            من الفكرة إلى <span className="gold-text">التسليم</span>
          </h2>
          <p className="mt-5 text-lg text-charcoal-300">
            نتّبع منهجية واضحة تضمن سير العمل بسلاسة وشفافية في كل مرحلة.
          </p>
        </Reveal>

        <div className="relative mt-16">
          {/* center line (desktop) */}
          <div className="absolute inset-y-0 right-1/2 hidden w-px translate-x-1/2 bg-gradient-to-b from-gold-500/0 via-gold-500/40 to-gold-500/0 lg:block" />

          <div className="space-y-6 lg:space-y-0">
            {processSteps.map((step, i) => {
              const isRight = i % 2 === 0
              return (
                <motion.div
                  key={step.number}
                  initial={{ opacity: 0, x: isRight ? 40 : -40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: '-60px' }}
                  transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                  className={`relative lg:flex lg:items-center ${
                    isRight ? 'lg:justify-start' : 'lg:flex-row-reverse lg:justify-start'
                  }`}
                >
                  <div className="lg:w-1/2 lg:px-10">
                    <div className="card-surface flex items-center gap-5 p-6 transition-all duration-300 hover:border-gold-500/40">
                      <span className="font-heading text-4xl font-black text-gold-500/40">
                        {step.number}
                      </span>
                      <div className="h-10 w-px bg-white/10" />
                      <h3 className="font-heading text-lg font-bold text-white sm:text-xl">
                        {step.title}
                      </h3>
                    </div>
                  </div>

                  {/* node */}
                  <span className="absolute right-1/2 top-1/2 hidden h-4 w-4 -translate-y-1/2 translate-x-1/2 rounded-full border-2 border-gold-400 bg-charcoal-950 lg:block" />
                </motion.div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
